import type { MouseEvent as ReactMouseEvent } from "react";
import { MarketingAppBar } from "./MarketingAppBar";
import type { LandingNavItem } from "./content";

interface Props {
  items: LandingNavItem[];
  activeSection: string;
  mobileMenuOpen: boolean;
  navScrolled: boolean;
  onToggleMenu: () => void;
  onAnchorClick: (
    href: string,
  ) => (event: ReactMouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

export function LandingNav({
  items,
  activeSection,
  mobileMenuOpen,
  navScrolled,
  onToggleMenu,
  onAnchorClick,
}: Props) {
  return (
    <MarketingAppBar
      items={items}
      activeItem={activeSection}
      brandHref="#top"
      brandOnClick={onAnchorClick("#top")}
      mobileMenuOpen={mobileMenuOpen}
      navScrolled={navScrolled}
      onToggleMenu={onToggleMenu}
      onItemClick={onAnchorClick}
    />
  );
}
